import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1489.35529,0 1920,430.644706 1920,960 C1920,1489.35529 1489.35529,1920 960,1920 C430.644706,1920 0,1489.35529 0,960 C0,430.644706 430.644706,0 960,0 Z M960,112.941176 C492.875294,112.941176 112.941176,492.875294 112.941176,960 C112.941176,1427.12471 492.875294,1807.05882 960,1807.05882 C1427.12471,1807.05882 1807.05882,1427.12471 1807.05882,960 C1807.05882,492.875294 1427.12471,112.941176 960,112.941176 Z M792.537449,756.191388 C800.543984,748.139643 811.551091,743.257495 822.908014,744.092479 L822.908014,744.092479 L1096.21054,744.092479 C1107.3003,744.092479 1117.2279,747.984336 1125.94492,756.191388 C1134.59515,764.399275 1139,774.124327 1139,785.814929 L1139,785.814929 L1139,1053.87132 L1063.02558,1053.87132 L1063.02558,1372 L855.974419,1372 L855.974419,1053.87132 L780,1053.87132 L780,785.814929 C780,774.102617 784.242044,764.376731 792.537449,756.191388 Z M960.023036,525 C1022.04593,525 1053,555.836569 1053,617.5557 C1053,678.518009 1022.0007,709 960.022199,709 C898.043699,709 867,678.518009 867,617.577443 L867,617.577443 L867,617.533121 C867,555.880891 897.999302,525 960.023036,525 Z",
  fillRule: "evenodd",
  stroke: "#979797",
  strokeWidth: "1"
});

var IconFilesObtainedPermissionSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconFilesObtainedPermissionSolid, _Component);

  var _super = _createSuper(IconFilesObtainedPermissionSolid);

  function IconFilesObtainedPermissionSolid() {
    _classCallCheck(this, IconFilesObtainedPermissionSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconFilesObtainedPermissionSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFilesObtainedPermission",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFilesObtainedPermissionSolid.displayName = "IconFilesObtainedPermissionSolid";
  return IconFilesObtainedPermissionSolid;
}(Component);

IconFilesObtainedPermissionSolid.glyphName = 'files-obtained-permission';
IconFilesObtainedPermissionSolid.variant = 'Solid';
IconFilesObtainedPermissionSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFilesObtainedPermissionSolid;
export { IconFilesObtainedPermissionSolid };